import { actionGenerator } from '../../utils/actionGenerator';

export enum EBrokerSelfRequestFormWidgetActionTypes {
  SetActive = 'brokerSelfRequestFormWidget/setActive',
  SetLoading = 'brokerSelfRequestFormWidget/setLoading',
}

export const setBrokerSelfRequestFormWidgetActive = actionGenerator<
  EBrokerSelfRequestFormWidgetActionTypes.SetActive,
  boolean
>(EBrokerSelfRequestFormWidgetActionTypes.SetActive);

export const setBrokerSelfRequestFormWidgetLoading = actionGenerator<
  EBrokerSelfRequestFormWidgetActionTypes.SetLoading,
  boolean
>(EBrokerSelfRequestFormWidgetActionTypes.SetLoading);

export type TBrokerSelfRequestFormWidgetActions =
  | ReturnType<typeof setBrokerSelfRequestFormWidgetActive>
  | ReturnType<typeof setBrokerSelfRequestFormWidgetLoading>;
